import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { CoachingHero, FeaturedIn } from "@/components/coaching/CoachingHero";
import { Programs } from "@/components/coaching/Programs";
import { AboutKelly, Book } from "@/components/coaching/AboutKelly";
import { CoachingCta } from "@/components/coaching/CoachingStories";

export default function Coaching() {
  return (
    <main data-testid="coaching-page" className="bg-white text-ink">
      <Navbar />
      <CoachingHero />
      <AboutKelly />
      <FeaturedIn />
      <Programs />
      <Book />
      <CoachingCta />
      <Footer />
    </main>
  );
}
